import Collaborate from './CollaborateContainer';
export default Collaborate;